import { ChangeEvent, ReactElement, forwardRef } from 'react'

import classnames from 'classnames'

import { DEFAULT_NAME, LEVELS } from './constants'

import Icons from 'common/components/icons'

const inputArray = Array.from(Array(LEVELS + 1).keys()).slice(1)

export interface Props {
  className?: string,
  name?: string,
  onChange?: (value: number) => void,
  readonly?: boolean,
  value?: number,
  required?: boolean,
  disabled?: boolean
}

const Rate = forwardRef<HTMLInputElement, Props>((
  {
    className,
    name = DEFAULT_NAME,
    onChange,
    readonly = false,
    required = false,
    value = 0,
    disabled = false
  },
  forwardedRef
) => {
  const onInputChange = (event: ChangeEvent<HTMLInputElement>) =>
    !readonly && onChange?.(parseInt(event.target.value, 10))

  const classes = classnames('rate', className, {
    'is-readonly': readonly,
    'is-invalid': required && !value,
    'is-disabled': disabled
  })

  return (
    <ol className={classes}>
      {
        inputArray.map((key: number): ReactElement<HTMLLIElement> => {
          const id = `${name}-${key}`

          return (
            <li key={key}>
              <input
                id={id}
                name={name}
                onChange={onInputChange}
                required={required}
                type="radio"
                value={key}
                disabled={disabled}
                ref={forwardedRef} />
              <label htmlFor={id}>
                <Icons prefix="fas" iconName="star" className={classnames({
                  'icon-fulfilled': key <= value,
                  'icon-placeholder': key > value
                })} />
                {
                  value > key - 1 && value < key
                  && <Icons prefix="fas" iconName="star-half" className="icon-half" />
                }
              </label>
            </li>
          )
        })
      }
    </ol>
  )
})

export default Rate
